import React from "react";
import "./Homepage.scss"

export const Home: React.FunctionComponent = () => {
    return(
        <div className="homepage">
            <h1 className="front-page-heading">Welcome! Site currently under construction.</h1>
        </div>
    )
}